import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ExpedicaoProduto } from '../../types/estoque';
import { expedicoesService } from '../../services';

const columns: ResourceColumn<ExpedicaoProduto>[] = [
  { header: 'Pedido', accessor: 'pedido_info' },
  { header: 'Transportadora', accessor: 'transportadora' },
  { header: 'Data de saida', accessor: 'data_saida' },
  { header: 'Quantidade', accessor: 'quantidade_expedida' },
  { header: 'Motorista', accessor: 'motorista' },
];

export const ExpedicoesListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Expedicoes"
    description="Romaneios expedidos."
    columns={columns}
    service={expedicoesService}
    createPath="/admin/estoque/expedicoes/novo"
      onEdit={(item) => item.id && navigate("/admin/estoque/expedicoes/editar", { state: { record: item } })}
  />
  );
};